//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {
        UiTagline: () => import('~/components/ui/tagline.vue'),
    },
    props: {
        currentContact: {
            type: Object,
            required: true,
        },
        overlap: {
            type: Boolean,
            default: false,
        },
        sendText: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
    },
};
